import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { TellentImpactTrackerEffects } from './store/tellent-impact-tracker.effects';
import {
  TellentImpactTrackerNamespace,
  TellentImpactTrackerReducer,
} from './store/tellent-impact-tracker.store';

const provideImpactTrackerState = provideState(
  TellentImpactTrackerNamespace,
  TellentImpactTrackerReducer,
);
const provideImpactTrackerEffects = provideEffects(TellentImpactTrackerEffects);

export const tellentImpactTrackerData = [provideImpactTrackerState, provideImpactTrackerEffects];
